import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from 'vue-router-multiguard';
import Provider from '../views/Provider.vue'
import Flow from '../views/Flow.vue';
import Pack from '../views/Pack.vue'
import Rental from '../views/Rental.vue';
import Continue from '../views/Continue.vue';
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Account from '../views/Account.vue'
import Unsubscribe from '../views/Unsubscribe.vue';
import Purchase from '../views/Purchase.vue';
import Vodacom from '../views/Purchase/Vodacom.vue'
import Safaricom from '../views/Purchase/Safaricom.vue'
import MTN from '../views/Purchase/MTN.vue'
import OTP from '../views/OTP.vue';
import Success from '../views/Success.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import DeviceFlowCode from '../views/DeviceFlow/Code.vue'
import DeviceFlowSuccess from '../views/DeviceFlow/Success.vue'
import Maintenance from '../views/Maintenance.vue';
import Error from '../views/Error.vue'
import AuthMiddleware from '../middleware/AuthMiddleware'
import DeviceFlowMiddleware from '../middleware/DeviceFlowMiddleware'
import ParameterMiddleware from '../middleware/ParameterMiddleware'
import GuestMiddleware from '../middleware/GuestMiddleware'
import FlowResetMiddleware from '../middleware/FlowResetMiddleware';

Vue.use(VueRouter)
Vue.config.devtools = true

const routes = [
    {
        path: '/',
        name: 'Vendors',
        component: Provider,
    },
    {
        path: '/flow',
        name: 'Flow',
        component: Flow,
    },
    {
        path: '/pack',
        name: 'Pack',
        component: Pack,
    },
    {
        path: '/rental',
        name: 'Rental',
        component: Rental,
    },
    {
        path: '/continue',
        name: 'Continue',
        component: Continue,
    },
    {
        path: '/purchase',
        name: 'Purchase',
        component: Purchase,
    },
    {
        path: '/error',
        name: 'Error',
        component: Error,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: multiguard([FlowResetMiddleware, GuestMiddleware]),
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        beforeEnter: GuestMiddleware,
    },
    {
        path: '/account',
        name: 'Account',
        component: Account,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/password/forgot',
        name: 'Forgot',
        component: ForgotPassword,
        beforeEnter: GuestMiddleware,
    },
    {
        path: '/password/reset/:token',
        name: 'Reset',
        component: ResetPassword,
        props: true,
        beforeEnter: GuestMiddleware,
    },
    {
        path: '/vodacom',
        name: 'Vodacom',
        component: Vodacom,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/safaricom',
        name: 'Safaricom',
        component: Safaricom,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/mtn',
        name: 'MTN',
        component: MTN,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/otp',
        name: 'OTP',
        component: OTP,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/confirmation',
        name: 'Confirmation',
        component: Success,
    },
    {
        path: '/unsubscribe',
        name: 'Unsubscribe',
        component: Unsubscribe,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/device',
        name: 'DeviceFlow',
        component: DeviceFlowCode,
        beforeEnter: AuthMiddleware,
    },
    {
        path: '/device/success',
        name: 'DeviceFlowSuccess',
        component: DeviceFlowSuccess,
        beforeEnter: DeviceFlowMiddleware,
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance,
    },
    {
        path: '/*',
        redirect: '/',
        component: Provider,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach(ParameterMiddleware)

export default router
